import { styled } from '@mui/system'
import Button from '../../molecules/button'

const SocialShareWrapper = styled('div')`
	margin-left: 20px;
	& .MuiTooltip-tooltip {
		padding: 10px;
	}
`

const ButtonStyled = styled(Button)`
	padding: 0;
	min-width: auto;
	min-height: auto;
	margin: 20px 20px 0 0;
	&:hover,
	&:focus,
	&:active {
		border-color: transparent;
		background: none;
	}
	& > span.MuiButton-startIcon {
		margin-right: 0;
		margin-left: 0;
	}
	${({ theme }) => theme.breakpoints.up('sm')} {
		margin: 0 20px 0 0;
	}
`

export { SocialShareWrapper, ButtonStyled }
